import { FoundCustomer } from './found-customer.model';

/**
 * Core vehicle data returned by `GET /vehicles/{vin}` (single-vehicle lookup),
 * before the current customer's relation types are known.
 * Use `CustomerVehicle` when the relation types are also available,
 * i.e. when the vehicle is returned as part of a customer's vehicle list.
 */
export interface BaseVehicle {
  name?: string;
  vin: string;
  licensePlate: string | undefined;
  /**
   * Present when the vehicle was loaded via `GET /vehicles/{vin}` (single-vehicle lookup).
   * Maps each relation type to the customer currently holding that relation on the vehicle.
   * Used in the add-relation modal to show which existing customer will be replaced.
   */
  allCustomers?: Partial<Record<CustomerVehicleRelationType, FoundCustomer>>;
}

/** Vehicle belonging to a customer, including which relation types the customer holds. */
export interface CustomerVehicle extends BaseVehicle {
  relationTypes: CustomerVehicleRelationType[];
}

export enum CustomerVehicleRelationType {
  USER = 'USER',
  OWNER = 'OWNER',
  KEEPER = 'KEEPER',
}

export enum C2vOperation {
  REMOVE_VEHICLES = 'C2V_REMOVE_VEHICLES',
  REMOVE_RELATIONS = 'C2V_REMOVE_RELATIONS',
  ADD_VEHICLES = 'C2V_ADD_VEHICLES',
  ADD_RELATIONS = 'C2V_ADD_RELATIONS',
  EDIT_LICENSE_PLATE = 'C2V_EDIT_LICENSE_PLATE',
}

/**
 * Model for editing customer-vehicle (C2V) relationships.
 * It's meant to describe the changes within the domain logic, as CustomerVehicle can't describe it as required.
 */
export interface EditVehicleRequest {
  vin: string;
  accountNumber: string;
  addRelationTypes: ReadonlySet<CustomerVehicleRelationType>;
  removeRelationTypes: ReadonlySet<CustomerVehicleRelationType>;
  registrationNumber?: string;
}
